import React, { useState } from 'react';
import Chat from './Chat';
interface Message {
  id: number;
  text: string;
  sender: "user" | "other";
  mediaUrl?: string;
  mediaType?: "image" | "audio";
  timestamp: string;
  isRead: boolean;
}
const Chatpage: React.FC = () => {
  const [messages, setMessages] = useState<Message[]>([]);
  const handleSendMessage = (
    text: string,
    mediaUrl?: string,
    mediaType?: "image" | "audio"
  ) => {
    if (text.trim() === "") return; 
    const newMessage: Message = {
      id: messages.length + 1,
      text,
      sender: "user", 
      timestamp: new Date().toISOString(), 
      isRead: false,
      mediaUrl, 
      mediaType
    };
    setMessages((prevMessages) => [...prevMessages, newMessage]);
  };
  const handleMarkAsRead = (id: number) => {
    setMessages((prevMessages) =>
      prevMessages.map((message) =>
        message.id === id ? { ...message, isRead: true } : message
      )
    );
  };
  const handleEditMessage = (id: number, newText: string) => {
    setMessages((prevMessages) =>
      prevMessages.map((message) =>
        message.id === id ? { ...message, text: newText } : message
      )
    );
  };
  const handleDeleteMessage = (id: number) => {
    setMessages((prevMessages) =>
      prevMessages.filter((message) => message.id !== id)
    );
  };
  return (
    <div>
        <Chat
        messages={messages} 
        onSendMessage={handleSendMessage}
        onMarkAsRead={handleMarkAsRead}
        onEditMessage={handleEditMessage}
        onDeleteMessage={handleDeleteMessage}
        />
    </div>
  );
};
export default Chatpage;
